import {
  FETCH_JOB_CANDIDATES,
  FETCH_JOB_CANDIDATES_SUCCESS,
  FETCH_JOB_CANDIDATES_FAILURE,
  FETCH_JOB_CANDIDATE_REQUEST,
  FETCH_JOB_CANDIDATE_SUCCESS,
  FETCH_JOB_CANDIDATE_FAILURE,
} from "./actionType";

export const fetchJobCandidates = (requestPayload) => {
  return {
    type: FETCH_JOB_CANDIDATES,
    payload: requestPayload,
  };
};

export const fetchJobCandidatesSuccess = (jobTimeline) => {
  return {
    type: FETCH_JOB_CANDIDATES_SUCCESS,
    payload: jobTimeline,
  };
};

export const fetchJobCandidatesFailure = (error) => {
  return {
    type: FETCH_JOB_CANDIDATES_FAILURE,
    payload: error,
  };
};

export const fetchJobCandidateId = (payload) => {
  return {
    type: FETCH_JOB_CANDIDATE_REQUEST,
    payload: { jobId: payload.jobId, candidateId: payload.candidateId },
  };
};

export const fetchJobCandidateIdSuccess = (jobCandidate) => {
  return {
    type: FETCH_JOB_CANDIDATE_SUCCESS,
    payload: jobCandidate,
  };
};

export const fetchJobCandidateIdFailure = (error) => {
  return {
    type: FETCH_JOB_CANDIDATE_FAILURE,
    payload: error,
  };
};
